// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1120px) {
  .hero_area {
    height: auto;
  }
  .slider_section {
    padding: 50px 0;
  }
}
@media (max-width: 992px) {
  .custom_nav-container .nav_search-btn {
    background-position: center;
  }
  .service_section .card-deck {
    flex-direction: column;
  }
  .service_section .card-deck .card {
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .slider_img-box {
    width: 85%;
    margin: 65px auto;
  }
  .slider_section .custom_carousel-control {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 105px;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;
  }
  .fruit_section .fruit_detail-box {
    margin-bottom: 40px;
    text-align: center;
  }
  .fruit_detail-box > div {
    display: flex;
    justify-content: center;
  }
  .contact_section {
    background-size: 105px;
  }
  .contact_section input {
    background-color: transparent;
  }
  .info_section .col-md-3 {
    text-align: center;
  }
  .info_section .col-md-3:not(:nth-last-child(1)) {
    margin-bottom: 35px;
  }
  .tasty_section h2 {
    font-size: 80px;
  }
}
@media (max-width: 576px) {
  .slider_item-container .slider_item-detail {
    text-align: center;
  }
  .slider_item-container .slider_item-detail .d-flex {
    justify-content: center;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1170px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAAA;EACI;IACI,YAAA;EACN;EAEE;IACI,eAAA;EAAN;AACF;AAIA;EACI;IACI,2BAAA;EAFN;EAKE;IAEI,sBAAA;EAJN;EAQE;IACI,mBAAA;EANN;AACF;AASA;EAEI;IAEI,UAAA;IACA,iBAAA;EATN;EAaE;IAEI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,YAAA;IACA,gCAAA;IACA,aAAA;IACA,8BAAA;EAZN;EAgBE;IAEI,mBAAA;IACA,kBAAA;EAfN;EAmBE;IAEI,aAAA;IACA,uBAAA;EAlBN;EAsBE;IACI,sBAAA;EApBN;EAuBE;IAEI,6BAAA;EAtBN;EA0BE;IACI,kBAAA;EAxBN;EA2BE;IAEI,mBAAA;EA1BN;EA6BE;IAEI,eAAA;EA5BN;AACF;AA+BA;EACI;IAEI,kBAAA;EA9BN;EAkCE;IAEI,uBAAA;EAjCN;AACF;AA2CA;EACI;IACI,iBAAA;EAzCN;AACF","sourcesContent":["@media (max-width: 1120px) {\n    .hero_area {\n        height: auto;\n    }\n\n    .slider_section {\n        padding: 50px 0;\n\n    }\n}\n\n@media (max-width: 992px) {\n    .custom_nav-container .nav_search-btn {\n        background-position: center;\n    }\n\n    .service_section .card-deck {\n\n        flex-direction: column;\n\n    }\n\n    .service_section .card-deck .card {\n        margin-bottom: 25px;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .slider_img-box {\n\n        width: 85%;\n        margin: 65px auto;\n\n    }\n\n    .slider_section .custom_carousel-control {\n\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        width: 105px;\n        transform: translate(-50%, -50%);\n        display: flex;\n        justify-content: space-between;\n\n    }\n\n    .fruit_section .fruit_detail-box {\n\n        margin-bottom: 40px;\n        text-align: center;\n\n    }\n\n    .fruit_detail-box>div {\n\n        display: flex;\n        justify-content: center;\n\n    }\n\n    .contact_section {\n        background-size: 105px;\n    }\n\n    .contact_section input {\n\n        background-color: transparent;\n\n    }\n\n    .info_section .col-md-3 {\n        text-align: center;\n    }\n\n    .info_section .col-md-3:not(:nth-last-child(1)) {\n\n        margin-bottom: 35px;\n    }\n\n    .tasty_section h2 {\n\n        font-size: 80px;\n    }\n}\n\n@media (max-width: 576px) {\n    .slider_item-container .slider_item-detail {\n\n        text-align: center;\n\n    }\n\n    .slider_item-container .slider_item-detail .d-flex {\n\n        justify-content: center;\n\n    }\n}\n\n@media (max-width: 480px) {}\n\n@media (max-width: 400px) {}\n\n@media (max-width: 360px) {}\n\n@media (min-width: 1200px) {\n    .container {\n        max-width: 1170px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
